import { WEB_URL } from "@/config/endpoints";


export function getServiceSchema({
  metaTitle,
  pageUrl,
  websiteLogo,
  mainImageUrl,
  metaDescription,
  pageName
}) {
  return {
    "@context": "https://schema.org",
    "@type": "FinancialService",
    "name": metaTitle,
    "url": pageUrl,
    "logo": WEB_URL+websiteLogo,
    ...(mainImageUrl && {
      image: WEB_URL+mainImageUrl,
    }),
    "description": metaDescription,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Smartworks Corporate Park (Tower B), 1st Floor, Sector 125",
      "addressLocality": "Noida",
      "addressRegion": "Uttar Pradesh",
      "postalCode": "201303",
      "addressCountry": "IN"
    },
    "areaServed": [
      {
        "@type": "Country",
        "name": "India"
      }
    ],
    "serviceType": pageName
  };
}
